import { FC, useState } from "react";
import { MdOutlineDashboardCustomize } from "react-icons/md";
import { XmButton } from "src/component/button/XmButton";
import SummaryDashboardSelect from "./SummaryDashboardSelect";

interface SummaryDashBtnProps {
  /** Item the summary template is built from. */
  itemId: string;
}

export const SummaryDashBtn: FC<SummaryDashBtnProps> = ({ itemId }) => {
  const [timestamp, setTimestamp] = useState(0);

  const onAddToDash = () => {
    setTimestamp(Date.now());
  };

  return (
    <div className="xm-summary-dash-btn">
      <SummaryDashboardSelect timestamp={timestamp} itemId={itemId} common={{ dashboardItems: [] }} />
      <XmButton title="Add summary to dashboard" type="text" onClick={onAddToDash}
        icon={<MdOutlineDashboardCustomize className="xm-icon-muted" />} className="xm-summary-dash-btn-icon" />
    </div>
  );
};
